import { render, staticRenderFns } from "./ClubFaqList.vue?vue&type=template&id=a52b5548&"
import script from "./ClubFaqList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClubFaqList.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a52b5548')) {
      api.createRecord('a52b5548', component.options)
    } else {
      api.reload('a52b5548', component.options)
    }
    module.hot.accept("./ClubFaqList.vue?vue&type=template&id=a52b5548&", function () {
      api.rerender('a52b5548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ClubInfo/components/ClubFaqList.vue"
export default component.exports